import { render } from "./twitterGeneral.vue?vue&type=template&id=d002afcc"
import script from "./twitterGeneral.vue?vue&type=script&lang=js"
export * from "./twitterGeneral.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__